const DATA_URL_PATTERN = /^data:image\//i;

const getImageSource = (
  base64String,
  mimeType
) => {
  const value = String(base64String || "").trim();

  if (!value) {
    return "";
  }

  if (
    DATA_URL_PATTERN.test(value) ||
    /^https?:\/\//i.test(value) ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  const detectedMimeType =
    mimeType ||
    (value.startsWith("/9j/")
      ? "image/jpeg"
      : value.startsWith("R0lGOD")
        ? "image/gif"
        : value.startsWith("UklGR")
          ? "image/webp"
          : "image/png");

  return `data:${detectedMimeType};base64,${value}`;
};

export default function ImagePreview({
  base64String,
  alt = "Question image",
  className = "",
  style,
  mimeType,
}) {
  const imageSource = getImageSource(
    base64String,
    mimeType
  );

  if (!imageSource) {
    return null;
  }

  return (
    <div
      className={`image-preview${
        className ? ` ${className}` : ""
      }`}
    >
      <img
        src={imageSource}
        alt={alt}
        style={style}
        loading="lazy"
      />
    </div>
  );
}